import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { Badge } from "primeng/badge";

@Component({
    selector: "kno2-badge",
    imports: [Badge],
    template: `
        <p-badge
            [value]="value()"
            [severity]="severity()"
            [badgeSize]="size()" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BadgeComponent {
    public readonly value = input<string>();
    public readonly severity = input<string>();
    public readonly size = input<"small" | "large" | "xlarge">();
}
